module.exports = __webpack_public_path__ + "static/img/logo.db4e372.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/logo.png
// module id = 6jHV
// module chunks = 1